export const MAP_KEYS_COMMISSIONS_FILE_TO_DB: Record<string, string> = {
    Administradora: 'administradora',
    'Xp code': 'xpCode',
    Contrato: 'contrato',
    Cliente: 'cliente',
    Grupo: 'grupo',
    Cota: 'cota',
    Bem: 'bem',
    'Crédito Contratadado': 'creditoContratado',
    Parcela: 'parcela',
    '% Repasse Monte Bravo': 'repasseMonteBravo',
    'Valor Monte Bravo': 'valorMonteBravo',
    'Status Pagamento Comissão': 'statusPagamentoComissao',
    'Data - Status Pagamento': 'dataStatusPagamento',
    'Data da venda': 'dataDaVenda',
    'Mês/Ano - Venda': 'mesAnoVenda',
    'Ano da venda': 'anoDaVenda',
};
